const CLIENTS = {
    DOCUMENTS: {
        text: 'Documents',
        route: 'clientDetailsDocuments',
        icon: 'ub-document'
    },
    REPORTS: {
        text: 'Reports',
        route: 'clientDetailsReports',
        icon: 'mdi-file'
    },
    EMPLOYEES: {
        text: 'Employees',
        route: 'clientDetailsEmployeesTable',
        icon: 'ub-employees'
    },
};

const EMPLOYEES = {
    DOCUMENTS: {
        text: 'Documents',
        route: 'employeeDetailsDocuments',
        icon: 'ub-document'
    },
    REPORTS: {
        text: 'Reports',
        route: 'employeeDetailsReports',
        icon: 'mdi-file'
    },
    CLIENTS: {
        text: 'Clients',
        route: 'employeeDetailsClientsTable',
        icon: 'ub-clients'
    },
};

export {
    CLIENTS,
    EMPLOYEES
}